import React from 'react';
import SmartCrypto from '../components/updated/SmartCryptoOld';
const SmartCryptoOldPage = () => {
  return <SmartCrypto />;
};

export default SmartCryptoOldPage;
